'use strict';

import 'document-register-element';
import dispatcher from '../dispatcher';

let idName = 'spoiler-id-';
let idNum = 0;
let items = {};




function _getId() {
  idNum++;
  return idName + idNum;
}

class Spoiler extends HTMLElement {
  constructor(self) {
    self = super(self);
    self.init.call(self);
  }
  init() {
    this.click = e => this._click(e);
  }
  connectedCallback() {
    this._id = this.dataset.id || _getId();

    this._button = this.querySelector(this.dataset.button || '.spoilerButton');
    this._content = this.querySelector(this.dataset.content || '.spoilerContent');
    this._scroll = this.dataset.scroll;
    this._group = this.dataset.group;
    this._active = this.classList.contains('active');

    this._button.addEventListener('click', this.click);

    items[this._id] = this;
  }
  disconnectedCallback() {
    delete items[this._id];
  }

  _click(e) {
    e.preventDefault();

    if (this._active) {
      this._close();
      return;
    }

    this._open();

    for (let key in items) {
      if (items.hasOwnProperty(key) && items[key]._id !== this._id && items[key]._group === this._group && items[key]._active) items[key]._close();
    }
  }
  _open() {
    this.classList.add('active');

    // TweenMax.fromTo(this, 0.3,{
    //   height: this._button.offsetHeight
    // }, {
    //   height: this._button.offsetHeight + this._content.scrollHeight,
    //   onCompleteScope: this,
    //   onComplete: this._onCompleteOpen
    // });

    this._onCompleteOpen();
    this._active = true;
  }

  _close() {
    this.classList.remove('active');
    this._content.style.overflow = 'hidden';

    // TweenMax.fromTo(this, 0.3, {
    //   height: this._button.offsetHeight + this._content.scrollHeight
    // }, {
    //   height: this._button.offsetHeight,
    //   onCompleteScope: this,
    //   onComplete: this._onCompleteClose
    // });

    this._onCompleteClose();
    this._active = false;
  }

  _onCompleteOpen() {
    this.style.height = 'auto';
    this.style.overflow = 'visible';

    if (this._scroll) {
      dispatcher.dispatch({
        type: 'scroll-to',
        _module: 'spoiler.component',
        elem: this._button,
        padding: 0.029
      });
    }

    dispatcher.dispatch({
      type: 'spoiler-change',
      _module: 'spoiler.component'
    })
  }

  _onCompleteClose() {
    this.style.height = '';

    dispatcher.dispatch({
      type: 'spoiler-change',
      _module: 'spoiler.component'
    });
  }

}

window.customElements.define('view-spoiler', Spoiler);